"use client";
import React, { FC } from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { CaretDownIcon } from "@radix-ui/react-icons";
import { Navigation } from "./types";
import ListItem from "./list-item";
import NavItemLabel from "./nav-item-label";

export type MainNavProps = { nav: Navigation };

const MainNav: FC<MainNavProps> = ({ nav }) => {
  const { navigationItems } = nav;
  return (
    <NavigationMenu.Root className=" hidden relative z-[1] md:flex  justify-end">
      <NavigationMenu.List className="center shadow-blackA7 m-0 flex list-none  bg-transparent">
        {navigationItems.map((menuItem, i) => {
          if (menuItem.subNavigation) {
            return (
              <NavigationMenu.Item key={menuItem.label} className="">
                <NavigationMenu.Trigger id ={`trigger-${menuItem.label}-${i}`}  aria-controls={`trigger-${menuItem.label}-${i}`} className=" text-white hover:text-[#05539c]  hover:bg-blue-300 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
                  <NavItemLabel navItem={menuItem} />
                  <CaretDownIcon
                    className="text-violet10 relative top-[1px] transition-transform duration-[250] ease-in group-data-[state=open]:-rotate-180"
                    aria-hidden
                  />
                </NavigationMenu.Trigger>

                <div className="absolute top-full flex justify-center w-[200px]">
                  <div className="  w-full  relative">
                    <NavigationMenu.Content className=" overflow-hidden rounded-[6px] bg-[#0c529c]  z-50 data-[motion=from-start]:animate-enterFromLeft data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToLeft data-[motion=to-end]:animate-exitToRight absolute top-0 left-0 w-full">
                      <ul className=" m-0  flex flex-col flex-grow list-none " >
                        {menuItem.subNavigation.listItems.map((listItem) => (
                          <ListItem
                            key={listItem.title}
                            url={listItem.url}
                            title={listItem.title}
                            message={listItem.message}
                          >
                            {listItem.message}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenu.Content>
                  </div>
                </div>
              </NavigationMenu.Item>
            );
          } else {
            return (
              <NavigationMenu.Item key={menuItem.label}>
                <NavigationMenu.Link id ={`trigger-${menuItem.label}-${i}`} 
                  className="hover:text-[#05539c]  hover:bg-blue-300 focus:shadow-violet7 block select-none rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none no-underline outline-none focus:shadow-[0_0_0_2px]"
                  href={menuItem.url}
                >
                  <NavItemLabel navItem={menuItem} />
                </NavigationMenu.Link>
              </NavigationMenu.Item>
            );
          }
        })}

        <NavigationMenu.Indicator className="data-[state=visible]:animate-fadeIn data-[state=hidden]:animate-fadeOut top-full z-[1] flex h-[10px] items-end justify-center overflow-hidden transition-[width,transform_250ms_ease]">
          <div className="relative top-[70%] h-[10px] w-[10px] rotate-[45deg] rounded-tl-[2px] bg-white" />
        </NavigationMenu.Indicator>
      </NavigationMenu.List>
    </NavigationMenu.Root>
  );
};

export default MainNav;
